// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__pO-cC","head":"ProcedureTableInfo_head__2oGbC"};